export default function isObject(value) {
    return typeof value === 'object' && value !== null;
}
//# sourceMappingURL=is-object.js.map